import { useTranslation } from "react-i18next";
import { MemberAccessItem } from "@/interface/ShareWindow/MemberAccessList/MemberAccessItem";
import type { MemberBoardData, Option } from "@/interface/ShareWindow/types";
import styles from "./MemberAccessList.module.scss";

export interface MemberAccessListType {
    members: MemberBoardData[];
    handler: (e: Option, accountId: number) => void;
    canEdit?: boolean;
}

export const MemberAccessList = ({ members = [], handler, canEdit }: MemberAccessListType) => {
    const { t } = useTranslation();
    return (
        <div className={styles.shareWindowPeople}>
            <p className={styles.title}>{t("share.accessSetup")}</p>

            <div className={styles.shareWindowPeopleList}>
                {members.map((member) => (
                    <MemberAccessItem
                        key={member.accountId}
                        member={member}
                        handler={handler}
                        canEdit={canEdit}
                    />
                ))}
            </div>
        </div>
    );
};
